import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Operations from '../../../../operations'
import Selectors from '../../../../selectors'
import { postJSON } from '../../../../common/services/api'
import { getNominative } from '../../../../common/utils'
import { find, some } from 'lodash'
import { isBrowser, isTablet } from 'react-device-detect'
import ConfirmationDialog from '../../../../LEGACY/ConfirmationDialog'
import {
  HelpLink,
  Icon,
  ListItem,
  Spinner,
} from '../../../../components/generic'
import { sizes, colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import _ from 'lodash'
import { InitialAssessmentPaywall } from './components'
import { ButtonOLD, EmptyState, NoDataIcon, PageHeader } from '@lmc/ui-kit'

import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'
import { ProTag } from 'components/ProTag'

const isDesktop = isBrowser || isTablet
export class ResidentInitialAssessmentDashboardScreen extends React.Component {
  state = {
    confirmationOpen: false,
  }

  componentDidMount() {
    const {
      fetchCarePlans,
      fetchInitialAssessments,
      features,
      router: {
        params: { id },
      },
    } = this.props

    if (features && features.carePlans && id) {
      fetchInitialAssessments(id)
      fetchCarePlans(id)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      features,
      fetchCarePlans,
      fetchInitialAssessments,
      router: {
        params: { id },
      },
    } = this.props

    if (features && features.carePlans && prevProps.router.params.id !== id) {
      fetchInitialAssessments(id)
      fetchCarePlans(id)
    }
  }

  createInitialAssessment = ({ carePlanAdl, resident }) => {
    postJSON({
      url: 'list/initial-assessments',
      method: 'POST',
      json: { carePlanAdl, resident },
    })
      .then((res) => this.redirectToItem(res.result))
      .catch((e) => {
        console.log(e)
      })
  }

  startInitialAssessment = () => {
    const {
      fetchResident,
      router: { params },
    } = this.props

    postJSON({
      url: `list/residents/${params.id}`,
      method: 'PUT',
      json: { isActiveInitialAssessment: true },
    })
      .then(() => fetchResident(params.id))
      .catch((e) => console.log(e))
  }

  createCarePlan = () => {
    const {
      fetchResident,
      router: { params },
    } = this.props
    postJSON({
      url: `list/residents/${params.id}/createCarePlan`,
      method: 'POST',
    })
      .then(() => {
        fetchResident(params.id)
        history.push(`/residents/${params.id}/care-plans`)
      })
      .catch((e) => console.log(e))
  }

  isNextStepDisabled = () => {
    const { initialAssessments } = this.props
    return (
      !initialAssessments ||
      !initialAssessments.length ||
      some(initialAssessments, ({ status }) => !status || status !== 'done')
    )
  }

  residentInPreAssessment = () => {
    const { resident } = this.props
    return (
      resident &&
      (resident.status === 'pre-assessment' ||
        resident.isActiveInitialAssessment)
    )
  }

  goToNextStep = () => {
    const {
      router: {
        params: { id },
      },
    } = this.props
    history.push(`/residents/${id}/initial-assessments/complete`)
  }

  handleSelect = (item) => {
    if (!item.id) {
      this.createInitialAssessment({
        carePlanAdl: item.carePlanAdl.id,
        resident: this.props.router.params.id,
        onComplete: this.redirectToItem,
      })
    } else {
      this.redirectToItem(item)
    }
  }

  redirectToItem = (item) => {
    const {
      router: { params },
    } = this.props
    history.push(`/residents/${params.id}/initial-assessments/${item.id}/edit`)
  }

  getSubLabel = (item) => {
    if (!item || !item.editedOn) return 'No updates yet'
    const carer = item.editedBy
    const date = dayjs(item.editedOn).format('DD-MM-YYYY • HH:mm')
    if (!carer || !carer.name) return <span>Updated {date}</span>
    return (
      <span>
        Updated {date} • {`${carer.name.first} ${carer.name.last}`}
      </span>
    )
  }

  toggleConfirmation = () => {
    this.setState((prevState) => ({
      confirmationOpen: !prevState.confirmationOpen,
    }))
  }

  isStartButtonEnabled = () => {
    const { carePlans } = this.props

    return (
      !carePlans.length ||
      _.every(carePlans, (c) => !c.nextReviewDate && c.revisions === 1)
    )
  }

  getShowStartInitialAssessment = () => {
    const { initialAssessments } = this.props

    return (
      !this.residentInPreAssessment() &&
      _.every(initialAssessments, (assessment) => !assessment.editedBy)
    )
  }

  renderHeader = () => {
    const {
      resident,
      router: { params },
      carePlanNominative,
      preferredPeopleNominative,
    } = this.props
    const fullName = `${resident.name.first} ${resident.name.last}`
    const subtitle = this.residentInPreAssessment()
      ? 'Complete all sections to finalise the Initial Assessment'
      : null

    const isStartButtonEnabled = this.isStartButtonEnabled()

    const showStartInitialAssessment = this.getShowStartInitialAssessment()

    return (
      <PageHeader
        title={`${fullName}'s Initial Assessment`}
        subtitle={subtitle}
        onBack={
          !isDesktop
            ? () => history.replace?.(`/residents/${params.id}/profile`)
            : undefined
        }
        sticky
      >
        <ProTag />
        {showStartInitialAssessment && (
          <>
            <ButtonOLD
              id="start-initial-assessment"
              disabled={!isStartButtonEnabled}
              onClick={this.toggleConfirmation}
              style={{
                ...styles.button,
                float: 'right',
                margin: '12px 0px 0px',
              }}
              type="primary"
            >
              Start Initial Assessment
            </ButtonOLD>
            <ConfirmationDialog
              buttonText="Start"
              buttonType="confirm"
              confirmationType="warning"
              isOpen={!!this.state.confirmationOpen}
              onCancel={this.toggleConfirmation}
              onConfirmation={this.startInitialAssessment}
            >
              <div>
                <p>{getInfo(carePlanNominative, preferredPeopleNominative)}</p>
              </div>
            </ConfirmationDialog>
          </>
        )}
      </PageHeader>
    )
  }

  renderDashboard = () => {
    const { initialAssessments } = this.props

    const showStartInitialAssessment = this.getShowStartInitialAssessment()

    if (showStartInitialAssessment) {
      return this.renderNoInitialAssessmentInfo()
    }

    return (
      <div style={styles.listContainer}>
        {initialAssessments.map((item, i) => {
          const adl = item.carePlanAdl
          return (
            <ListItem
              icon={adl.icon}
              iconColor={adl.color}
              key={i}
              label={adl.name}
              onSelect={() => this.handleSelect(item)}
              subLabel={this.getSubLabel(item)}
            >
              {this.renderRightIcon(item)}
            </ListItem>
          )
        })}
      </div>
    )
  }

  renderRightIcon = (item) => {
    let opts
    switch (item.status) {
      case 'done':
        opts = {
          color: colors.green,
          label: 'Done',
          icon: 'tick-in-circle',
        }
        break
      case 'draft':
        opts = {
          color: colors.orange,
          label: 'Draft',
          icon: 'pencil',
        }
        break
      default:
        return null
    }

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <span style={styles.statusLabel}>{opts.label}</span>
        <Icon name={opts.icon} fill={opts.color} size={24} />
      </div>
    )
  }

  renderNoInitialAssessmentInfo = () => {
    const { resident, carePlanNominative } = this.props

    const isStartButtonEnabled = this.isStartButtonEnabled()

    return (
      <div>
        <EmptyState
          title={
            isStartButtonEnabled
              ? `${
                  resident?.preferredName || resident.name.first
                } currently doesn't have an Initial Assessment.`
              : `${
                  resident?.preferredName || resident.name.first
                }'s Initial Assessment can no longer be added here, because changes have been made to their ${carePlanNominative}.`
          }
          icon={<NoDataIcon />}
          description={
            isStartButtonEnabled
              ? `You can add one here as long as no changes have been made to their ${carePlanNominative}.`
              : `If you'd like to upload an Initial Assessment, you can do this in Documents.`
          }
        />
      </div>
    )
  }

  renderFooter = () => {
    const { resident } = this.props
    if (
      resident.status !== 'pre-assessment' &&
      !resident.isActiveInitialAssessment
    )
      return null
    return (
      <div
        className="lmc-fixed-footer"
        style={{
          ...styles.footer,
        }}
      >
        <ButtonOLD
          id="initial-assessment-next-step"
          disabled={this.isNextStepDisabled()}
          onClick={
            resident.isActiveInitialAssessment
              ? this.createCarePlan
              : this.goToNextStep
          }
          style={styles.button}
          type="primary"
        >
          Finalise Initial Assessment
        </ButtonOLD>
      </div>
    )
  }

  render() {
    const { carePlans, features, initialAssessments, resident, hasCarePlans } =
      this.props

    if (!hasCarePlans) {
      return <InitialAssessmentPaywall />
    }

    if (
      !carePlans ||
      !features ||
      !features.carePlans ||
      !resident ||
      !initialAssessments ||
      !initialAssessments.length
    ) {
      return <Spinner />
    }

    return (
      <div>
        <div style={styles.wrapper}>
          {this.renderHeader()}
          <div style={styles.dashboard}>{this.renderDashboard()}</div>
          <HelpLink supportLink={SUPPORT_ARTICLE} />
        </div>
        {this.renderFooter()}
      </div>
    )
  }
}

const getInfo = (carePlanNominative, preferredPeopleNominative) =>
  `If you start an Initial Assessment for this ${getNominative(
    preferredPeopleNominative,
    'resident'
  )}, you won't be able to update their ${getNominative(
    carePlanNominative,
    'Care Plan'
  )} until the assessment is complete.`

const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/3376538-how-do-i-use-initial-assessments'

const styles = {
  boldText: {
    fontWeight: 600,
  },
  button: {
    color: 'white',
    padding: '0px 25px',
    textShadow: 'none',
    marginRight: 20,
  },
  confirmHeader: {
    fontWeight: 600,
    fontSize: 18,
  },
  dashboard: {
    paddingTop: 24,
  },
  divider: {
    height: 2,
    marginBottom: 18,
    marginTop: 8,
    width: '100%',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  listContainer: {
    marginBottom: 40,
  },
  statusLabel: {
    paddingRight: 10,
    alignSelf: 'center',
    display: 'block',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    color: colors.black,
  },
  title: {
    marginBottom: 0,
  },
  wrapper: {
    padding: '0px 0px 50px',
    margin: '0 auto',
    maxWidth: sizes.childScreen,
  },
}

ResidentInitialAssessmentDashboardScreen.propTypes = {
  features: PropTypes.object,
  fetchCarePlans: PropTypes.func.isRequired,
  fetchInitialAssessments: PropTypes.func.isRequired,
  fetchResident: PropTypes.func.isRequired,
  resident: PropTypes.object,
}

const mapStateToProps = (state, props) => ({
  carePlans: state.data['care-plans'],
  features: state.global.home,
  initialAssessments: Selectors.getResidentInitialAssessments(state, props),
  resident: find(state.data.residents, { id: props.router.params.id }),
  carePlanNominative: state.global.home.preferredCarePlansNominative,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  hasCarePlans: state.global.home.features.carePlans?.enabled,
})

const mapDispatchToProps = (dispatch) => ({
  fetchCarePlans: (resident) =>
    dispatch(
      Operations.loadList('care-plans', {
        resident,
        isRevision: false,
      })
    ),
  fetchInitialAssessments: (resident) =>
    dispatch(Operations.loadList('initial-assessments', { resident })),
  fetchResident: (id) => dispatch(Operations.loadListItem('residents', id)),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResidentInitialAssessmentDashboardScreen)
)
